import { LinkItemSchema } from '@/views/sports/components/CompetitionsMenu/styles/LinkItem.styles';

export const linkItemStyles: LinkItemSchema = {
  link: {
    bg: 'alpha.300',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    py: '2',
    pl: '3',
    pr: '2',
    mb: '1px',
    color: 'alpha.900',
    _last: {
      mb: '0',
    },
    _hover: {
      textDecoration: 'none',
    },
  },
  textCompetitionName: {
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxW: '140px',
  },
  textMatchCount: {
    px: '1',
    fontSize: '2xs',
    fontWeight: 'bold',
  },
};
